<div class="dialog">
  <form [formGroup]="form">
    <h4 mat-dialog-title>{{ 'common_section_identification' | translate }}</h4>
    <mat-card>
      <mat-form-field>
        <mat-label>{{ 'common_field_label' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="data?.scenario.displayName" [value]="data?.scenario.displayName" [ngModelOptions]="{ standalone: true }" cdkFocusInitial required />
        <mat-error *ngIf="!data?.scenario.displayName" [innerHTML]="'dialog_scenario_error_label_required' | translate"></mat-error>
      </mat-form-field>
    </mat-card>
    <h4 mat-dialog-title>{{ 'dialog_scenario_title_scenario' | translate }}</h4>
    <mat-card>
      <mat-form-field>
        <mat-label>{{ 'dialog_scenario_field_comment_general' | translate }}</mat-label>
        <textarea type="text" [(ngModel)]="data?.scenario.comment_general" [value]="data?.scenario.comment_general" [ngModelOptions]="{ standalone: true }" rows="2" matInput></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'dialog_scenario_field_comment_tables' | translate }}</mat-label>
        <textarea type="text" [(ngModel)]="data?.scenario.comment_tables" [value]="data?.scenario.comment_tables" [ngModelOptions]="{ standalone: true }" rows="2" matInput></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'dialog_scenario_field_comment_summary' | translate }}</mat-label>
        <textarea type="text" [(ngModel)]="data?.scenario.comment_summary" [value]="data?.scenario.comment_summary" [ngModelOptions]="{ standalone: true }" rows="2" matInput></textarea>
      </mat-form-field>
      <h4 mat-dialog-title>{{ 'common_section_indicators' | translate }}</h4>
      <div class="row">
        <div class="col-4" *ngFor="let item of data.indicators">
          <mat-checkbox (change)="valueChange(data.indicators, item, $event)" [checked]="item?.isChecked">{{ item?.displayName | localizedLabel: 'indicator' : item?.code }}</mat-checkbox>
        </div>
      </div>
    </mat-card>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
